<template>
    <div>
        <!-- banner -->
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/picture/banner/B3.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 应用案例 -->
                        {{ $t('case.case_banner_title') }}
                    </h1>
                    <h3>
                        <!-- 服务于高铁、船舶、机械、钢构、冶金、石化等不同行业 -->
                         {{ $t('case.case_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                            {{ $t('case.case_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <!-- 应用案例 -->
                            {{ $t('case.case_banner_title') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>

         <!-- 菜单 -->
         <section class="menu_common" >
            <div class="container" >
                <div class="faq-page__tab">
                    <div class=" faq-page__tab-box  tabs-box">
                        <div class=" menu_row tab-buttons">
                                <div class="menu_li">
                                        <div data-tab="#pressureVessel" class="menu_li_title tab-btn pressureVessel_li active-btn " @click="handleReplace()">
                                            <!-- 压力容器行业 -->
                                            {{ $t('case.case_menu_pressureVessel') }}
                                        </div>
                                </div>
                                <div  class="menu_li" >
                                    <div data-tab="#mechanical" class="menu_li_title tab-btn  mechanical_li" @click="handleReplace()" >
                                        <!-- 机械制造行业 -->
                                        {{ $t('case.case_menu_mechanical') }}
                                    </div>
                                </div>
                                <div class="menu_li">
                                        <div data-tab="#weldingTraining" class=" menu_li_title tab-btn weldingTraining_li" @click="handleReplace()">
                                            <!-- 焊培行业 -->
                                            {{ $t('case.case_menu_weldingTraining') }}
                                        </div>
                                </div>
                                <div  class="menu_li">
                                        <div data-tab="#coalMachine" class="menu_li_title tab-btn coalMachine_li" @click="handleReplace()">
                                            <!-- 煤机行业 -->
                                            {{ $t('case.case_menu_coalMachine') }}
                                        </div>
                                </div>
                                <div class="menu_li " >
                                        <div data-tab="#steelStructure" class=" menu_li_title tab-btn steelStructure_li" @click="handleReplace()">
                                            <!-- 钢结构行业 -->
                                            {{ $t('case.case_menu_steelStructure') }}
                                        </div>
                                </div>
                                <div class="menu_li" >
                                        <div data-tab="#piping" class="menu_li_title tab-btn piping_li" @click="handleReplace()">
                                            <!-- 管道行业 -->
                                            {{ $t('case.case_menu_piping') }}
                                        </div>
                                </div>
                                <div class="menu_li" >
                                        <div data-tab="#ship" class="menu_li_title tab-btn ship_li" @click="handleReplace()">
                                            <!-- 船舶行业 -->
                                            {{ $t('case.case_menu_ship') }}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          
        </section>
       
        <!-- 内容 -->
        <section class="welcome-one">
            <div class="container">
                <div class="faq-page__tab">
                    <div class="faq-page__tab-box tabs-box">
                        <div class="row">
                          
                            <!-- 内容 -->
                            <div class="col-xl-12 col-lg-12">
                             
                                <div class="tabs-content" v-show="!previewShow">
                                    <!--tab 压力容器行业-->
                                    <div class="tab active-tab" id="pressureVessel">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.pressureVesselList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                                <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name"> 
                                                                <!-- {{ item.title }} -->
                                                                 {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                                <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <!--tab 机械制造行业-->
                                    <div class="tab " id="mechanical">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.mechanicalList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                 <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                               <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name"> 
                                                                <!-- {{ item.title }} -->
                                                                 {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                 <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                                <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a> 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <!--tab 焊培行业-->
                                    <div class="tab " id="weldingTraining">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.weldingTrainingList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                 <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                                <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name"> 
                                                            <!-- {{ item.title }} -->
                                                                 {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                 <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                                <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <!--tab煤机行业-->
                                    <div class="tab" id="coalMachine">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.coalMachineList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                 <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                                <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name"> 
                                                                <!-- {{ item.title }} -->
                                                                 {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                 <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                             <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <!--tab 钢结构-->
                                    <div class="tab" id="steelStructure">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.steelStructureList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                                 <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name"> 
                                                                 <!-- {{ item.title }} -->
                                                                 {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                  <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                             <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="tab" id="piping">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.pipingList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                 <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                                 <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name"> 
                                                                <!-- {{ item.title }} -->
                                                                {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                  <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                                 <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="tab" id="ship">
                                        <div class="row">
                                            <div class="col-xl-4 col-lg-6 col-md-12 wow fadeInUp" v-for="(item,index) in caseParams.shipList" :key="index" :data-wow-delay="(index+1)+'ms'">
                                                <div class="team-one__single" @click="handleDetail(item, index)">
                                                    <div class="team-one__img">
                                                        <img :src="item.pictureUrl" alt="" style="height: 370px;">
                                                        <ul class="list-unstyled team-one__social">
                                                            <li>
                                                                <!-- 交付日期： -->
                                                                  {{ $t('case.case_card_deliveryDate') }}
                                                                {{ item.time }}</li>
                                                            <li>
                                                                <!-- 焊接数量：  -->
                                                                {{ $t('case.case_card_weldingQuantity') }}
                                                                {{ item.weldingQuantity }}</li>
                                                            
                                                        </ul>
                                                    </div>
                                                    <div class="team-one__content-box">
                                                        <div class="team-one__content">
                                                            <h4 class="team-one__name">  
                                                                <!-- {{ item.title }} -->
                                                                {{ $t(`case.${item.i18n_title}`) }}
                                                            </h4>
                                                            <p class="team-one__title"> 
                                                                <!-- {{ item.text }} -->
                                                                {{ $t(`case.${item.i18n_text}`) }}
                                                            </p>
                                                            <a  class="thm-btn project-one__btn">
                                                             <!-- 查看更多 -->
                                                                {{ $t('case.case_card_viewMore') }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <template v-if="previewShow">
                                    <img class="tabs__img" :src="previewImg" alt="">
                                </template>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script >
// import res from '../../common/json/case/caseList.json'
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'list',
    mixins: [MixinsList],
    components: {

    },
    data () {
        return {
            routeList: [],  // 面包屑
            caseParams: {},  // 数据
            previewShow: false,  // 预览最新
            previewImg: "",
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.case_li').addClass('current');
  
        if ($(".tabs-box").length) {
            $(".tabs-box .tab-buttons .tab-btn").on("click", function (e) {
            e.preventDefault();
            var target = $($(this).attr("data-tab"));
            if ($(target).is(":visible")) {
                return false;
            } else {
                // target
                // .parents(".tabs-box")
                // .find(".tab-buttons")
                // .find(".tab-btn")
                $(".active-btn").removeClass("active-btn");
                $(this).addClass("active-btn");


                target
                .parents(".tabs-box")
                .find(".tabs-content")
                .find(".tab")
                .fadeOut(0);
                target
                .parents(".tabs-box")
                .find(".tabs-content")
                .find(".tab")
                .removeClass("active-tab");
                $(target).fadeIn(300);
                $(target).addClass("active-tab");
            }
            });
        }
        // var param = this.$route.query
        // if(param.type && param.classification) {
        //     $('.active-btn').removeClass('active-btn');  
        //     $('.active-tab').removeClass('active-tab');  
        //    var classParam = param.classification + '_li'
        //    $('.'+classParam).addClass("active-btn");
        //    $('#'+param.classification).addClass("active-tab");
     
        //    var arr = this.caseParams[param.classification + 'List']
        //    var valParam = arr.find((item)=> {
        //         return item.type == param.type
        //     })
            
        //     // if(this.$i18n.locale == 'zh_CN') {
        //     //     this.previewImg = valParam.previewUrl_zh  // 客户案例图片
        //     // } else if(this.$i18n.locale == 'en_US') {
        //     //    this.previewImg = valParam.previewUrl_en  // 客户案例图片
        //     // }else if(this.$i18n.locale == 'ru_RU') {
        //     //     this.previewImg = valParam.previewUrl_ru  // 客户案例图片
        //     // }
        //     this.previewImg = valParam.previewUrl
        //     this.previewShow = true
        // } 

    },
    methods: {
        // 获取内容
        async getList() {
            // const { result } = res
            // this.caseParams = JSON.parse(JSON.stringify(result.caseParams))  // 软件产品

            // Object.keys(this.caseParams).forEach((key) => {
            //     var item = this.caseParams[key]

            //     item.forEach((cItem) => {
            //         if(this.$i18n.locale == 'zh_CN') {
            //            cItem.previewUrl = cItem.previewUrl  // 客户案例图片
            //         } else if(this.$i18n.locale == 'en_US') {
            //            cItem.previewUrl = cItem.previewUrl_en  // 客户案例图片
            //         }else if(this.$i18n.locale == 'ru_RU') {
            //             cItem.previewUrl = cItem.previewUrl_ru  // 客户案例图片
            //         }
            //     })
            // })

            const result = await loadData('caseList', this.lang)
            this.caseParams = JSON.parse(JSON.stringify(result.caseParams))  // 软件产品

            this.initRouteParam()
        },
         // 处理路由参数（依赖 caseParams 数据）
        initRouteParam() {
            var param = this.$route.query
            if(param.type && param.classification) {
                $('.active-btn').removeClass('active-btn');  
                $('.active-tab').removeClass('active-tab');  
                var classParam = param.classification + '_li'
                $('.'+classParam).addClass("active-btn");
                $('#'+param.classification).addClass("active-tab");
                var arr = this.caseParams[param.classification + 'List']
                if (!arr || !arr.length) {
                    console.error('数据不存在:', param.classification + 'List')
                    return
                }
                var valParam = arr.find((item) => {
                    return item.type == param.type
                })
                if (valParam) {
                    this.previewImg = valParam.previewUrl
                    this.previewShow = true
                }
            }
        },
        // 打开详情
        handleReplace() {
            this.previewShow = false
        },
        // 详情
        handleDetail(item, index) {
            this.previewImg = item.previewUrl
            this.previewShow = true
        }
    }
}
</script>
<style scoped>

@media (max-width: 1000px){
    .menu_li {
        width: 30%;
        padding: 30px 0;
    }
}

.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    font-size: var(--font-size-40);
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}


.menu_common {
    width: 100%;
    box-shadow: 0 5px 70px 0 rgba(63, 101, 171, 0.1);
    background: #fff;
}
.menu_row {
    display: flex;
    justify-content: space-between;
}
.menu_li {
    width: 13%;
    padding: 30px 0;
     display: flex;
    align-items: stretch;
}
.menu_li_title {
    border: 1px solid var(--notech-bdr-color);
    font-size: var(--font-size-20);
    font-weight: 700;
    padding: 10px 10px;
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
   
}
.active-btn {
    background-color: var(--notech-base);
    color: var(--notech-white);
}
.menu_li:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 2px;
    height: 20px;
    background: #eeeeee;
    transition: all 0.36s;
}

.welcome-one {
    min-height: calc(60vh);
    background: var(--notech-extra);
    padding: 60px 0 120px; 
}

.team-one__social {
    position: absolute;
    top: 30px;
    left: 30px;
    transform: scaleX(0);
    transform-origin: center;
    transform-style: preserve-3d;
    transition: all 500ms ease;
    z-index: 2;
}

.team-one__social li {
    padding: 5px 12px;
    margin: 6px 0;
    width: auto;
    background-color: var(--notech-base);
    color: #fff;
    font-size: var(--font-size-16);
    display: table;
}

.team-one__content-box {
    text-align: left;
}
.team-one__content {
    position: relative;
    display: block;
    padding: 32px 20px 33px;
    overflow: hidden;
    z-index: 1;
}
.team-one__title {
    width: 100%;
    height: 75px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
}

.li_item {
    display: flex;
    justify-content: space-between;
    
}

.faq-page__tab-box .tab-buttons .tab-btn.active-btn .faq-page__tab-button-content  {
    background-color: var(--notech-base);
}
.faq-page__tab-box .tab-buttons .tab-btn.active-btn .faq-page__tab-button-content  p{
    color: var(--notech-white);
}
.faq-page__tab-box .tab-buttons .tab-btn .faq-page__tab-button-content {
    padding: 10px 15px;
}
.project-one__btn {
    margin-top: 30px;
    color: var(--notech-black);
    width: auto;
    padding: 4px 30px;
    background-color: var(--notech-extra);
}
.team-one__single {
    cursor: pointer;
}
.team-one__single:hover .project-one__btn{
    background-color: var(--notech-base);
    color: #fff;
}
.team-one__name {
    font-size: var(--font-size-20);
}
.tabs__img{
    max-width: 100%;
}
.team-one__img img{
    width: 100%;
}
.faq-page__tab-button-box {
    margin-right: 0;
}
</style> 
